import "./Map.css";
import "./MapVues.css";

import React, { useEffect, useMemo, useState } from "react";
import {
  getLogs,
  getServeursNonRemontes,
  setSelectedBuild,
  setShowLogsModal,
} from "../../redux/actions/logsActions";
import { useDispatch, useSelector } from "react-redux";

import Breadcrumb from "./Breadcrumb";
import Minimap from "./Minimap";
import {
  BarreFiltresMap,
  MessageAucunResultat,
  MessageNonRemonte,
  TableauJobs,
} from "./BarreFiltresMap";
import { CartesChiffres, LegendeMap, MapEntete } from "./MapEntete";
import { PanneauEnvironnement } from "./PanneauEnvironnement";
import VueMatrice from "./VueMatrice";
import VueHexagones from "./VueHexagones";
import VueTreemap from "./VueTreemap";
import Vue3DConteneur from "./Vue3DConteneur";
import {
  FILTRES_VIDES,
  agregerEnv,
  calculerKpi,
  collecterEnvs,
  collecterJobs,
  compterParCategorie,
  compterServeursNonRemontes,
  construireArbreNonRemontes,
  filtrerArbre,
  filtresActifs,
  fusionnerArbres,
  parseFiltresQuery,
  regrouperParCategorie,
  serialiserFiltresQuery,
} from "./filtresMap";
import { Spin, message } from "antd";
import { useHistory } from "react-router-dom";

function Map2() {
  /* ---------------------------------- Hooks --------------------------------- */
  const logsBrut = useSelector((state) => state.logs.logs);
  const loading = useSelector((state) => state.logs.loading);
  const [currentLogs, setCurrentLogs] = useState({});
  const [path, setPath] = useState(["racine"]);
  const [selectedNode, setSelectedNode] = useState({});
  const dispatch = useDispatch();
  const history = useHistory();
  // Segments de l'URL a l'arrivee (lien profond / chargement a froid), lus une seule fois.
  const pendingDeepLink = React.useRef(
    parseMapSegments(history.location.pathname)
  );
  // Filtres et presentation (query string cat/statut/q/vue), restaures a l'arrivee.
  const [filtres, setFiltres] = useState(() =>
    parseFiltresQuery(history.location.search)
  );
  const [qSaisie, setQSaisie] = useState(filtres.q);
  const search = serialiserFiltresQuery(filtres);
  const searchRef = React.useRef(search);
  searchRef.current = search;
  const sawLoading = React.useRef(false);
  const replaceNext = React.useRef(false);

  // Serveurs non remontes (BI-682) : charges en parallele de /api/logs, sans le retarder.
  // null = en erreur (carte "—") ; la map reste utilisable.
  const [nrListe, setNrListe] = useState(null);
  const [nrCharge, setNrCharge] = useState(false);
  const rechargerNr = React.useCallback(() => {
    let annule = false;
    getServeursNonRemontes().then((liste) => {
      if (annule) return;
      setNrListe(Array.isArray(liste) ? liste : null);
      setNrCharge(true);
    });
    return () => {
      annule = true;
    };
  }, []);

  useEffect(() => {
    dispatch(getLogs());
    return rechargerNr();
  }, [dispatch, rechargerNr]);

  const serveursActif = filtres.statuts.includes("serveurs");
  const statutsAutres = useMemo(
    () => filtres.statuts.filter((st) => st !== "serveurs"),
    [filtres.statuts]
  );
  // Filtres appliques aux traitements : la carte "serveurs" n'est pas un statut de traitement.
  const filtresNormaux = useMemo(
    () => (serveursActif ? { ...filtres, statuts: statutsAutres } : filtres),
    [serveursActif, filtres, statutsAutres]
  );
  const nrArbre = useMemo(() => construireArbreNonRemontes(nrListe), [nrListe]);
  // Arbre source de la navigation : logs inchange (meme reference) quand la carte est inactive ;
  // sinon noeuds non remontes seuls, ou union avec les logs si un autre statut est coche (H6).
  const union = serveursActif && statutsAutres.length > 0;
  const logs = useMemo(() => {
    if (!serveursActif) return logsBrut;
    return union ? fusionnerArbres(logsBrut, nrArbre) : nrArbre;
  }, [serveursActif, union, logsBrut, nrArbre]);

  useEffect(() => {
    const target = "/map/" + path.join("/");
    // Lien profond non encore resolu : ne pas ecraser l'URL d'arrivee.
    if (pendingDeepLink.current) return;
    if (replaceNext.current) {
      replaceNext.current = false;
      history.replace(target + searchRef.current);
    } else if (history.location.pathname !== target) {
      history.push(target + searchRef.current);
    }
  }, [path, history]);

  // Reflet des filtres dans l'URL sans empiler l'historique.
  useEffect(() => {
    if (pendingDeepLink.current) return;
    const { pathname, search: courant } = history.location;
    if (courant !== search) {
      history.replace(pathname + search);
    }
  }, [search, history]);

  // Recherche temporisee (debounce).
  useEffect(() => {
    if (qSaisie.trim() === filtres.q) return;
    const t = setTimeout(
      () => setFiltres((f) => ({ ...f, q: qSaisie.trim() })),
      300
    );
    return () => clearTimeout(t);
  }, [qSaisie, filtres.q]);

  // Resolution du chemin complet apres le (re)chargement des donnees.
  useEffect(() => {
    if (loading) {
      sawLoading.current = true;
      return;
    }
    if (!pendingDeepLink.current || !sawLoading.current) {
      return;
    }
    // carte active en lien profond : attendre la route des serveurs non remontes.
    if (serveursActif && !nrCharge) return;
    if (!logs.children) {
      // chargement en echec : abandonner le lien profond pour ne pas bloquer la navigation.
      pendingDeepLink.current = null;
      return;
    }
    const resolved = resolveMapPath(logs, pendingDeepLink.current);
    pendingDeepLink.current = null;
    if (!resolved.complete) {
      message.warning("Nœud introuvable sur la map");
    }
    const samePath = resolved.path.join("/") === path.join("/");
    setSelectedNode(resolved.dataNode);
    setCurrentLogs(resolved.renderNode);
    if (samePath) {
      // le state ne change pas : normaliser l'URL sans entree d'historique.
      history.replace("/map/" + resolved.path.join("/") + searchRef.current);
    } else {
      replaceNext.current = true;
      setPath(resolved.path);
    }
  }, [loading, logs, path, history, serveursActif, nrCharge]);

  useEffect(() => {
    if (logs.children) {
      setCurrentLogs(logs);
    }
  }, [logs]);

  // Activation / desactivation de la carte : retour a la racine de l'arbre correspondant.
  const serveursPrec = React.useRef(serveursActif);
  useEffect(() => {
    if (serveursPrec.current === serveursActif) return;
    serveursPrec.current = serveursActif;
    setSelectedNode(logs);
    setCurrentLogs(logs);
    setPath((p) => (p.length > 1 ? ["racine"] : p));
  }, [serveursActif, logs]);

  /* -------------------------- Preparation functions ------------------------- */

  const handleDrillChange = React.useCallback(
    (nodeName) => {
      const { dataNode, renderNode } = findNode(logs, nodeName, path);
      setSelectedNode(dataNode);
      setCurrentLogs(renderNode);
      const nodeNameIndex = path.findIndex((node) => node === nodeName);
      let modPath = [...path];
      if (nodeName === "racine") {
        setPath(["racine"]);
      } else {
        modPath.splice(nodeNameIndex + 1, modPath.length - (nodeNameIndex + 1));
        setPath(modPath);
      }
    },
    [logs, path]
  );

  const handleShowModal = React.useCallback(
    (e, node, historyIndex = null) => {
      e.stopPropagation();
      if (historyIndex !== null) {
        dispatch(
          setSelectedBuild({
            build: node.data.history[historyIndex][1],
            traitement_id: node.data.traitement_id,
          })
        );
      } else {
        dispatch(
          setSelectedBuild({
            build: node.data.no_build,
            traitement_id: node.data.traitement_id,
          })
        );
      }
      dispatch(setShowLogsModal());
    },
    [dispatch]
  );

  const zoom = React.useCallback(
    (d, node) => {
      const name = node.data.name;
      let prevPath = [];
      if (node.data.type === "server") {
        prevPath = ["racine", node.data.group_name, name];
      } else if (node.data.type === "client") {
        if (node.parent.data.type === "server") {
          prevPath = [
            "racine",
            node.data.group_name,
            node.data.server_name,
            name,
          ];
        } else {
          prevPath = ["racine", node.data.group_name, name];
        }
      } else {
        prevPath = ["racine", name];
      }
      const { dataNode } = findNode(logs, name, prevPath);
      setSelectedNode(dataNode);

      if (node.data.type === "client") {
        if (node.parent.data.type === "server") {
          setPath([
            "racine",
            node.data.group_name.toLowerCase(),
            node.data.server_name.toLowerCase(),
            name.toLowerCase(),
          ]);
        } else {
          setPath([
            "racine",
            node.data.group_name.toLowerCase(),
            name.toLowerCase(),
          ]);
        }
      } else if (node.data.type === "server") {
        setPath([
          "racine",
          node.data.group_name.toLowerCase(),
          node.data.name.toLowerCase(),
        ]);
      } else {
        setPath(["racine", node.data.name.toLowerCase()]);
      }
      // Arbre non filtre (les filtres sont appliques a l'affichage, pas au state).
      const source = dataNode || node.data;
      const treemapData = source.children ?? source.jobs;

      // env non remonte : le noeud lui-meme (message dedie, pas de liste de traitements)
      setCurrentLogs(source.nonRemonte && source.type === "client" ? source : { name, children: treemapData });
    },
    [logs]
  );

  /* ---------------------------- Filtres / presentation ---------------------------- */

  const handleFiltresChange = React.useCallback(
    (patch) => setFiltres((f) => ({ ...f, ...patch })),
    []
  );
  const handleVue = React.useCallback(
    (vue) => setFiltres((f) => ({ ...f, vue })),
    []
  );
  const handleReset = React.useCallback(() => {
    setQSaisie("");
    setFiltres({ ...FILTRES_VIDES });
  }, []);

  // Ouverture de la modale de logs (build explicite, sinon dernier build du traitement).
  const handleOpenLogs = React.useCallback(
    (job, historyIndex = null) => {
      const entree =
        historyIndex !== null && Array.isArray(job.history) ? job.history[historyIndex] : null;
      dispatch(
        setSelectedBuild({
          build: entree ? entree[1] : job.no_build,
          traitement_id: job.traitement_id,
        })
      );
      dispatch(setShowLogsModal());
    },
    [dispatch]
  );
  const handleRowClick = React.useCallback((job) => handleOpenLogs(job), [handleOpenLogs]);

  // Panneau lateral de detail d'un environnement (matrice, hexagones, 3D, tuile sans traitement).
  const [panneau, setPanneau] = useState(null);
  const ouvrirPanneau = React.useCallback(
    (env, categorie = null) => setPanneau({ env, categorie }),
    []
  );
  const fermerPanneau = React.useCallback(() => setPanneau(null), []);
  const handleEnvSansTuile = React.useCallback(
    (node) =>
      ouvrirPanneau(
        agregerEnv(
          {
            group: node.data.group_name,
            server: node.data.server_name,
            env: node.data.name,
            code: node.data.code_client_cti,
            finess: node.data.finess_id,
            vague: node.data.vague_name,
          },
          node.data.jobs
        )
      ),
    [ouvrirPanneau]
  );

  const displayLogs = useMemo(
    () => filtrerArbre(currentLogs, filtresNormaux),
    [currentLogs, filtresNormaux]
  );
  const lignes = useMemo(() => collecterJobs(displayLogs), [displayLogs]);
  const envs = useMemo(() => collecterEnvs(displayLogs), [displayLogs]);
  const envsSans = useMemo(() => envs.filter((e) => e.sans), [envs]);
  const compteurs = useMemo(
    () => compterParCategorie(currentLogs, filtresNormaux),
    [currentLogs, filtresNormaux]
  );
  // Cartes de traitements : les noeuds non remontes ne sont jamais comptes ; carte seule
  // active -> perimetre global des logs (l'arbre courant ne contient que des non remontes).
  const nrSeul = serveursActif && statutsAutres.length === 0;
  const kpi = useMemo(() => {
    const k = calculerKpi(nrSeul ? logsBrut : currentLogs, filtresNormaux);
    // compte de la carte : perimetre global, recherche texte appliquee, "—" si route en erreur
    k.serveurs = nrListe === null ? null : compterServeursNonRemontes(nrArbre, filtres.q);
    return k;
  }, [nrSeul, logsBrut, currentLogs, filtresNormaux, nrListe, nrArbre, filtres.q]);
  const envsNr = useMemo(() => envs.filter((e) => e.nonRemonte), [envs]);
  const envNrOuvert =
    displayLogs && displayLogs.nonRemonte && displayLogs.type === "client" ? displayLogs : null;
  const vide =
    filtresActifs(filtres) &&
    !!currentLogs.children &&
    lignes.length === 0 &&
    envs.length === 0;
  const vue = filtres.vue;
  // Au niveau environnement, traitements regroupes en sous-cadres par categorie.
  const treeData = useMemo(() => regrouperParCategorie(displayLogs), [displayLogs]);

  /* --------------------------------- Navigation --------------------------------- */

  // Retour/avance navigateur : l'URL complete est resolue une seule fois par entree
  // d'historique (SX-537). history.action reste "POP" jusqu'au prochain push : dependre de
  // handleDrillChange (recree a chaque setPath) relancait l'effet en boucle et annulait les
  // clics ; handleDrillChange ne savait pas non plus redescendre (bouton avance).
  useEffect(() => {
    if (history.action === "POP" && logs.children && !pendingDeepLink.current) {
      const resolved = resolveMapPath(logs, parseMapSegments(history.location.pathname));
      setSelectedNode(resolved.dataNode);
      setCurrentLogs(resolved.renderNode);
      replaceNext.current = true;
      setPath(resolved.path);
    }
  }, [history.location.key, history.location.pathname, logs, history]);

  /* --------------------------------- Render --------------------------------- */

  if (loading || (serveursActif && !nrCharge)) {
    return <Spin style={{ width: "100%", marginTop: "50vh" }} />;
  }

  let contenu;
  if (vide) {
    contenu = <MessageAucunResultat onReset={handleReset} serveurs={nrSeul} />;
  } else if (vue === "tableau") {
    contenu = (
      <TableauJobs
        lignes={lignes}
        onRowClick={handleRowClick}
        envsSans={envsSans}
        onEnvClick={ouvrirPanneau}
        envsNonRemontes={envsNr}
      />
    );
  } else if (vue === "matrice") {
    contenu = (
      <VueMatrice
        envs={envs}
        categories={filtres.categories}
        onCellule={ouvrirPanneau}
        onEnv={ouvrirPanneau}
      />
    );
  } else if (vue === "hex") {
    contenu = <VueHexagones envs={envs} onEnv={ouvrirPanneau} />;
  } else if (vue === "3d") {
    contenu = <Vue3DConteneur envs={envs} onEnv={ouvrirPanneau} />;
  } else if (envNrOuvert) {
    contenu = <MessageNonRemonte dernierBuild={envNrOuvert.dernierBuild} />;
  } else {
    contenu = (
      <VueTreemap
        data={treeData}
        path={path}
        onZoom={zoom}
        onJob={handleShowModal}
        onEnvSans={handleEnvSansTuile}
      />
    );
  }

  return (
    <div className="map-page">
      <MapEntete vue={vue} onVue={handleVue} />
      <CartesChiffres kpi={kpi} statuts={filtres.statuts} onChange={handleFiltresChange} />
      <BarreFiltresMap
        filtres={filtres}
        qSaisie={qSaisie}
        onQSaisie={setQSaisie}
        onChange={handleFiltresChange}
        onReset={handleReset}
        compteurs={compteurs}
      />
      <div className="map-header">
        <div className="map-breadcrumb">
          <Breadcrumb path={path} handleDrillChange={handleDrillChange} />
        </div>
        <div className="map-minimap">
          <Minimap node={selectedNode} />
        </div>
      </div>
      <div className={`map-vue${vue === "tableau" ? " sans-cadre" : ""}`}>{contenu}</div>
      <LegendeMap vue={vue} nonRemonteActif={serveursActif} />
      <PanneauEnvironnement
        env={panneau && panneau.env}
        categorie={panneau && panneau.categorie}
        onClose={fermerPanneau}
        onOpenLogs={handleOpenLogs}
      />
    </div>
  );
}

export default React.memo(Map2);

/* ---------------------------------- Utils --------------------------------- */

function flattenLogs(logs) {
  let flatLogs = [];
  logs.forEach((group) => {
    flatLogs.push(group);
    if (group.children) {
      flatLogs = flatLogs.concat(...flattenLogs(group.children));
    }
  });
  return flatLogs;
}

export function findNode(logs, nodeName, path) {
  const clickedIndex = path.findIndex(
    (pathItem) => pathItem.toLowerCase() === nodeName.toLowerCase()
  );
  let node = logs;
  let renderNode = node;
  if (clickedIndex !== 0) {
    const flatLogs = flattenLogs(logs.children);
    if (clickedIndex === 1) {
      node = flatLogs.find(
        (node) =>
          node.name && node.name.toLowerCase() === nodeName.toLowerCase()
      );
      renderNode = node;
    } else if (clickedIndex === 2) {
      node = flatLogs.find(
        (node) =>
          node.name &&
          node.group_name &&
          node.group_name.toLowerCase() ===
            path[clickedIndex - 1].toLowerCase() &&
          node.name.toLowerCase() === nodeName.toLowerCase()
      );
      renderNode = {
        name: nodeName,
        children: node.jobs ?? node.children,
      };
    } else {
      node = flatLogs.find(
        (node) =>
          node.name &&
          node.code_client_cti &&
          node.group_name.toLowerCase() ===
            path[clickedIndex - 2].toLowerCase() &&
          node.code_client_cti.toLowerCase() === nodeName.toLowerCase()
      );
      renderNode = node.nonRemonte ? node : { name: nodeName, children: node.jobs };
    }
  }
  return { dataNode: node, renderNode };
}

/* Lecture de l'URL /map/<groupe>/<serveur>/<env> (segment "racine" optionnel). */
export function parseMapSegments(pathname) {
  const parts = String(pathname || "")
    .split("/")
    .filter(Boolean);
  if (parts[0] !== "map") return null;
  let segs = parts.slice(1).map((p) => {
    try {
      return decodeURIComponent(p);
    } catch (e) {
      return p;
    }
  });
  if (segs.length && segs[0].toLowerCase() === "racine") segs = segs.slice(1);
  return segs.length ? segs.slice(0, 3) : null;
}

const same = (a, b) =>
  typeof a === "string" &&
  typeof b === "string" &&
  a.toLowerCase() === b.toLowerCase();

/*
 * Resout [groupe, serveur, env] (insensible a la casse) sur l'arbre des logs.
 * Retourne le dernier niveau resolu : { path, dataNode, renderNode, complete }.
 * Ne leve jamais d'exception.
 */
export function resolveMapPath(logs, segments) {
  const out = {
    path: ["racine"],
    dataNode: logs,
    renderNode: logs,
    complete: false,
  };
  const groups = Array.isArray(logs && logs.children) ? logs.children : [];
  const segs = Array.isArray(segments) ? segments : [];
  if (!segs.length) return { ...out, complete: true };
  const flat = flattenLogs(groups);
  const [g, s, e] = segs.map((x) => String(x).toLowerCase());

  const group = groups.find((n) => n && same(n.name, g));
  if (!group) return out;
  out.path = ["racine", g];
  out.dataNode = group;
  out.renderNode = group;
  if (segs.length === 1) return { ...out, complete: true };

  // Deux structures (cf. formatLogs) : groupe avec niveau serveur (g/s/e) ou groupe a un seul
  // serveur sans niveau serveur (enfants = environnements) : g/e ou g/s/e (s ignore), chemin
  // normalise ["racine", g, e] comme la navigation manuelle.
  const isEnv = (n) => n && (n.type === "client" || n.jobs !== undefined);
  const children = Array.isArray(group.children) ? group.children : [];
  const sansServeur = children.length > 0 && children.every(isEnv);
  // L'env se reconnait par son code client ou son nom (la navigation manuelle utilise le nom).
  const matchEnv = (n, v) =>
    isEnv(n) &&
    same(n.group_name, g) &&
    (same(n.code_client_cti, v) || same(n.name, v));

  if (sansServeur) {
    const envSeg = segs.length >= 3 ? e : s;
    const envNode = flat.find((n) => matchEnv(n, envSeg));
    if (!envNode) return out;
    out.path = ["racine", g, envSeg];
    out.dataNode = envNode;
    out.renderNode = envNode.nonRemonte ? envNode : { name: envSeg, children: envNode.jobs };
    return { ...out, complete: true };
  }

  const server = flat.find((n) => n && same(n.group_name, g) && same(n.name, s));
  if (!server) return out;
  out.path = ["racine", g, s];
  out.dataNode = server;
  out.renderNode = { name: s, children: server.jobs ?? server.children };
  if (segs.length === 2) return { ...out, complete: true };

  const env = flat.find(
    (n) => matchEnv(n, e) && (!n.server_name || same(n.server_name, s))
  );
  if (!env) return out;
  out.path = ["racine", g, s, e];
  out.dataNode = env;
  out.renderNode = env.nonRemonte ? env : { name: e, children: env.jobs };
  return { ...out, complete: true };
}
